<template>
  <TsNuxtCard
    :data-testid="props.dataTestid + '-available-payment-methods-card'"
    no-shadow
    :append-class="
      algoliaStore.enableNewCheckoutFlow
        ? 'bg-white p-4 md:pt-6 md:pb-5 border-0'
        : 'bg-white px-3 py-5 rounded-md border-[#7BBAF5]'
    "
  >
    <!-- NEW FLOW -->
    <template v-if="algoliaStore.enableNewCheckoutFlow">
      <div
        class="flex flex-col md:flex-row md:items-center md:py-[14px] p-4 mb-5 justify-center border rounded-md md:border-[#7BBAF5]"
      >
        <div class="flex md:items-center">
          <TsIcon name="material-symbols:lock-outline" size="20" class="mr-1.5 text-primary" />
          <TsTypography
            weight="semibold"
            append-class="mb-1 leading-[12px] text-idle-black"
            :data-testid="props.dataTestid + '-payment-secure-transaction-text'"
          >
            {{ useTranslation('Chekout-secureTransaction', '100% Secure transaction') }}

            <p
              v-if="isMobileScreen"
              class="py-2 text-natural-grey"
              :data-testid="props.dataTestid + '-payment-secure-ssl-encryption-text'"
            >
              {{ useTranslation('Checkout-secureEncryptionTitle', 'Secure SSL Encryption') }}
            </p>
          </TsTypography>
        </div>

        <!-- Logos -->
        <PaymentLogos :dataTestid="props.dataTestid" />
      </div>

      <span class="text-[12px]">
        {{ useTranslation('checkout-footer', ' ') }}
      </span>
    </template>

    <!-- OLD FLOW -->
    <template v-else>
      <div class="flex">
        <TsIcon name="material-symbols:lock-outline" size="20" class="mr-1.5 text-primary" />
        <div class="mb-4">
          <TsTypography
            weight="semibold"
            append-class="mb-1 leading-[12px] text-idle-black"
            :data-testid="props.dataTestid + '-payment-secure-transaction-text'"
          >
            {{ useTranslation('Chekout-secureTransaction', '100% Secure transaction') }}
            <br />
          </TsTypography>

          <p :data-testid="props.dataTestid + '-payment-secure-ssl-encryption-text'">
            {{ useTranslation('Checkout-secureEncryptionTitle', 'Secure SSL Encryption') }}
          </p>
        </div>
      </div>

      <!-- Logos -->
      <PaymentLogos :dataTestid="props.dataTestid" />
    </template>
  </TsNuxtCard>
</template>

<script lang="ts" setup>
import { useTranslation } from '~/composables/useTranslation';
const PaymentLogos = defineAsyncComponent(
  () => import('~/components/organisms/TsPaymentLogos.vue')
);

const algoliaStore = useAlgoliaStore();
const { isMobileScreen } = useScreenSize();

const TsNuxtCard = defineAsyncComponent(() => import('~/components/organisms/TsNuxtCard.vue'));

type Props = {
  dataTestid: string;
};
const props = withDefaults(defineProps<Props>(), {});
</script>
